<template>
  <div class="container">
    <h3>Service</h3>
    <ul class="event-tree">
      <li v-for="(service,key) in registry" :key="key">
        <span class="esource" @click="toggle(key)">{{ key }}</span>
        <ul v-if="toggles[key]" :id="key" class="group-tree">
          <li v-for="(controller,ckey) in service" :key="ckey">
            <span class="egroup" @click="toggle(key + '-' + ckey)">{{ ckey }}</span>
            <ul v-if="toggles[key + '-' + ckey]" class="event-tree">
              <li v-for="(method,mkey) in controller" :key="mkey" class="esignal">
                <span @click="selectMethod(key,ckey,mkey)" class="esignal">{{ mkey }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: ["registry"],
  data() {
    return {
      toggles: {}
    }
  },
  created() {
  },
  methods: {
    toggle(key) {
      console.log('toggle: ',key);
      this.toggles[key] = !this.toggles[key];
      this.$forceUpdate();
    },
    selectMethod(mod,controller,method) {
      var service = this.registry[mod][controller][method];
      console.log('selected',mod,controller,method,service);
      this.$emit('selected',mod,controller,method,service);
    }
  }
}
</script>

<style>
.event-tree {
  list-style: none;
}
.event-tree li {
  margin-top: 8px;
}
.esource {
  padding: 6px 10px;
  background-color: #dde;
  border-radius: 3px;
  font-size: 18px;
  font-weight: bold;
}
.egroup {
  padding: 4px 8px;
  background-color: #ded;
  border-radius: 3px;
  font-size: 14px;
  font-weight: bold;
}
.esignal {
  padding: 3px 6px;
  background-color: #eed;
  border-radius: 3px;
  font-size: 12px;
}
.group-tree {
  list-style: none;
}
</style>
